import { Address } from 'nftx.js';
import Price from '@/presentation/components/elements/Price';
import { useEnsName } from 'wagmi';
import ellipsis from '@/presentation/utils/ellipsis';
import { useNetwork } from '@/presentation/context/network';
import Link from 'next/link';
import { URLS } from '@/presentation/utils/urls';

const TopStaker = ({
  userAddress,
  value,
}: {
  userAddress: Address;
  poolShare: bigint;
  value: bigint;
}) => {
  const { slug: chain } = useNetwork();
  const { data: ensName } = useEnsName({ address: userAddress });

  return (
    <tr className="text-sm">
      <td className="p-2">
        <Link
          href={`/${chain}/${URLS.PROFILE_POSITIONS}?user=${userAddress}`}
          className="hover:underline"
        >
          {ensName || ellipsis(userAddress)}
        </Link>
      </td>
      <td className="text-right p-2">
        <Price value={value} />
      </td>
    </tr>
  );
};

export default TopStaker;
